module.exports = __webpack_public_path__ + "img/icon-login.d8caed27.svg";